import MonkeyTable from './MonkeyTable'
export default MonkeyTable
